import { palette } from '../palette'

export const MuiMenu = {
  styleOverrides: {
    root: {
      marginTop: '10px',
      boxShadow: 'none',
      '.MuiPaper-root': {
        minWidth: '240px',
        border: `1px solid ${palette.cyan[500]}`,
        borderRadius: '10px',
        '.MuiMenu-list': {
          padding: 0,
          '.MuiMenuItem-root:first-of-type': {
            paddingTop: '16px',
          },
          '.MuiMenuItem-root:last-of-type': {
            paddingBottom: '16px',
          },
        },
      },
    },
  },
}
